export const SYSMSG_CONST = {
    clickTypeTarget: "System Alert",
    clickTrackSection: "Header",
    clickTrackSectionModal: "System Alert",
    linkType: "CTA",
    pageTypeModal: "Modal",
    clickNameOK: "OK",
    clickNameClose: "Close"
}